import script from "./CourseFAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseFAQ.vue?vue&type=script&setup=true&lang=js"

import "./CourseFAQ.vue?vue&type=style&index=0&id=24fa0c21&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24fa0c21"]])

export default __exports__